<div class="flex flex-column gap-2">
  <toolbar (search)="search($event)" [actions]="toolbarActions" [title]="''"></toolbar>
  <dynamic-table [headers]="columns" [data]="data" [actions]="actions"></dynamic-table>
</div>
